
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/challenges/puzzles",
      function () {
        return require("private-next-pages/challenges/puzzles.tsx");
      }
    ]);
  